import { Link } from 'react-router-dom';

const CATEGORIES = [
  {
    href: '/medical-gloves',
    icon: 'ri-heart-pulse-line',
    en: 'Medical Gloves',
    ar: 'القفازات الطبية',
    desc: 'Surgical, examination & sterile gloves for hospitals and clinics.',
    descAr: 'قفازات جراحية وفحص ومعقمة للمستشفيات والعيادات.',
    tag: 'Latex-Free Available',
    color: 'from-navy/90 to-navy/70',
    img: 'https://public.readdy.ai/ai/img_res/976945815cea6226a969cb8f7d17d32b.jpg',
  },
  {
    href: '/food-grade-gloves',
    icon: 'ri-restaurant-2-line',
    en: 'Food Grade Gloves',
    ar: 'قفازات المواد الغذائية',
    desc: 'Food-safe vinyl, polyethylene & catering gloves for F&B sector.',
    descAr: 'قفازات فينيل وبولي إيثيلين وتقديم الطعام الآمنة للأغذية.',
    tag: 'Food Safe',
    color: 'from-brand-green/90 to-brand-green/70',
    img: 'https://readdy.ai/api/search-image?query=transparent%20clear%20polyethylene%20food%20handling%20gloves%20on%20kitchen%20counter%2C%20food%20service%20professional%20setting%2C%20clean%20white%20background%2C%20commercial%20product%20photography&width=600&height=400&seq=cat-food-01&orientation=landscape',
  },
  {
    href: '/lab-gloves',
    icon: 'ri-flask-line',
    en: 'Lab Gloves',
    ar: 'قفازات المختبر',
    desc: 'Nitrile powder-free & chemical resistant gloves for laboratories.',
    descAr: 'قفازات نيتريل خالية من البودرة ومقاومة للمواد الكيميائية للمختبرات.',
    tag: 'Chemical Resistant',
    color: 'from-navy/90 to-navy/70',
    img: 'https://readdy.ai/api/search-image?query=scientist%20wearing%20purple%20nitrile%20powder%20free%20gloves%20in%20laboratory%20environment%2C%20test%20tubes%20and%20lab%20equipment%20visible%2C%20clean%20sterile%20laboratory%20setting%2C%20professional%20photography&width=600&height=400&seq=cat-lab-01&orientation=landscape',
  },
  {
    href: '/industrial-gloves',
    icon: 'ri-tools-line',
    en: 'Industrial Gloves',
    ar: 'القفازات الصناعية',
    desc: 'Heavy duty, cut resistant & industrial PPE gloves for factories.',
    descAr: 'قفازات الحماية الشخصية الثقيلة ومقاومة القطع للمصانع.',
    tag: 'Heavy Duty PPE',
    color: 'from-gray-800/90 to-gray-700/70',
    img: 'https://readdy.ai/api/search-image?query=industrial%20worker%20wearing%20thick%20orange%20heavy%20duty%20protective%20gloves%20in%20modern%20factory%2C%20machinery%20in%20background%2C%20safety%20equipment%2C%20professional%20industrial%20photography&width=600&height=400&seq=cat-industrial-01&orientation=landscape',
  },
  {
    href: '/bulk-wholesale',
    icon: 'ri-stack-line',
    en: 'Bulk & Wholesale',
    ar: 'الجملة والبالة',
    desc: 'Tiered wholesale pricing — 1K to 50K+ boxes. Supply contracts.',
    descAr: 'أسعار جملة متدرجة — من 1000 إلى 50000 صندوق وأكثر. عقود التوريد.',
    tag: 'Volume Discounts',
    color: 'from-brand-green/90 to-navy/80',
    img: 'https://readdy.ai/api/search-image?query=large%20warehouse%20with%20stacked%20cardboard%20boxes%20of%20disposable%20gloves%20on%20pallets%2C%20organized%20industrial%20wholesale%20distribution%20center%2C%20high%20ceiling%20storage%20facility&width=600&height=400&seq=cat-bulk-01&orientation=landscape',
  },
  {
    href: '/request-quote',
    icon: 'ri-file-list-3-line',
    en: 'Request a Quote',
    ar: 'طلب عرض سعر',
    desc: 'Get a custom wholesale quote within 24 hours. WhatsApp preferred.',
    descAr: 'احصل على عرض سعر جملة مخصص خلال 24 ساعة. يُفضّل واتساب.',
    tag: '24hr Response',
    color: 'from-navy/90 to-navy-dark/90',
    img: 'https://readdy.ai/api/search-image?query=professional%20business%20meeting%20in%20modern%20office%2C%20people%20reviewing%20documents%20and%20pricing%20proposals%2C%20clean%20corporate%20environment%2C%20natural%20lighting&width=600&height=400&seq=cat-quote-01&orientation=landscape',
  },
];

export default function ProductCategories() {
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="text-center mb-12">
          <span className="trust-badge mb-4 inline-flex">🧤 Our Product Range</span>
          <h2 className="section-title-en text-3xl md:text-4xl mb-2">
            Wholesale Gloves for Every Industry
          </h2>
          <p className="section-title-ar text-2xl md:text-3xl" dir="rtl">
            قفازات بالجملة لكل صناعة
          </p>
          <p className="text-gray-600 text-sm mt-3 max-w-xl mx-auto">
            Supplying quality gloves across medical, food, laboratory and industrial sectors
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop>
          {CATEGORIES.map((cat) => (
            <Link
              key={cat.href}
              to={cat.href}
              className="group relative overflow-hidden rounded-xl cursor-pointer block hover:-translate-y-1 transition-transform duration-200"
            >
              {/* Image */}
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={cat.img}
                  alt={`${cat.en} - omandisposables.com Oman`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Overlay */}
              <div className={`absolute inset-0 bg-gradient-to-t ${cat.color}`} />
              {/* Tag */}
              <div className="absolute top-3 left-3 bg-white/20 backdrop-blur-sm text-white text-xs font-semibold px-3 py-1 rounded-full">
                {cat.tag}
              </div>
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/20 mb-3">
                  <i className={`${cat.icon} text-white text-xl`} />
                </div>
                <h3 className="font-heading font-bold text-white text-lg mb-0.5">{cat.en}</h3>
                <p className="font-arabic text-white/90 text-sm text-right mb-2" dir="rtl">{cat.ar}</p>
                <p className="text-white/85 text-xs leading-relaxed">{cat.desc}</p>
                <div className="mt-3 flex items-center text-white text-xs font-semibold gap-1 group-hover:gap-2 transition-all">
                  View Details <i className="ri-arrow-right-line" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
